import { useCallback } from 'react'
import { getRebuildValueMeterForm as getRebuildValueMeterFormApi, getHouseholdValueMeterForm as getHouseholdValueMeterFormApi } from '../api/value_meter_forms'
import { setHouseHoldValueMeterForm, setRebuildValueMeterForm, setIsLoading } from '../state/slices/value_meter_forms_slice'
import { useAppDispatch } from './state'

export const useValueMeterForms = () => {
  const dispatch = useAppDispatch()

  const getHouseHoldValueMeterForm = useCallback(async () => {
    dispatch(setIsLoading(true))

    try {
      const result = await getHouseholdValueMeterFormApi()

      if (result.data) {
        dispatch(setHouseHoldValueMeterForm(result.data))
      }

      return true
    } catch (err) {
      return false
    } finally {
      dispatch(setIsLoading(false))
    }
  }, [dispatch])

  const getRebuildValueMeterForm = useCallback(async () => {
    dispatch(setIsLoading(true))

    try {
      const result = await getRebuildValueMeterFormApi()

      if (result.data) {
        dispatch(setRebuildValueMeterForm(result.data))
      }

      return true
    } catch (err) {
      return false
    } finally {
      dispatch(setIsLoading(false))
    }
  }, [dispatch])

  return {
    getHouseHoldValueMeterForm,
    getRebuildValueMeterForm
  }
}

export default useValueMeterForms
